import { render, staticRenderFns } from "./dialog-auth-form.vue?vue&type=template&id=1e883fc8&scoped=true"
import script from "./dialog-auth-form.vue?vue&type=script&lang=js"
export * from "./dialog-auth-form.vue?vue&type=script&lang=js"
import style0 from "./dialog-auth-form.vue?vue&type=style&index=0&id=1e883fc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e883fc8",
  null
  
)

export default component.exports